import { notification } from "antd";
/**
 *
 * @param {*} type error|warn|success
 * @param {*} msg payload to show
 */
export const notify = (type, msg) => {
    switch (true) {
        case type === "error":
            // message.error(msg);
            notification.error({
                message: `Error`,
                description: msg,
                placement: "topRight",
                // duration: 0,
            });
            break;
        case type === 'Access Denied':
            // message.error(msg);
            notification.error({
                message: 'Access Denied',
                description: msg,
                placement: "topRight",
                // duration: 0,
            });
            break;
        case type === "warn":
            notification.info({
                message: `Warning`,
                description: msg,
                placement: "topRight",
                // duration: 0,
            });
            break;
        case type === "info":
            notification.info({
                message: `Info`,
                description: msg,
                placement: "topRight",
                // duration: 0,
            });
            break;
        case type === "success":
        default:
            notification.success({
                message: `Success`,
                description: msg,
                placement: "topRight",
                // duration: 0,
            });
            break;
    }
};

export const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
};